import React, { useEffect } from "react";
import { Map, useMap } from "react-mapkit";

import { RedIconSVG } from "../../utils/Images";

import { JobIconSVG, JobIconOrange } from "../../utils/Images";

const DEFAULT_LATITUDE_SPAN = 0.2;
const DEFAULT_LONGITUDE_SPAN = 0.2;

/**
 * @param {number} latitude
 * @param {number} longitude
 */
const ProjectAppleMap = ({ latitude, longitude, type }) => {
  const { map, mapProps, mapkit, setRegion } = useMap();
  console.log(type,'jobTypejobType')
  useEffect(() => {
    if (map) {
      map.removeAnnotations(map.annotations);
      var pinOptions = {
        url: { 1: type == 'employer'? JobIconOrange : RedIconSVG },
        size: { width: 40, height: 40 },
        anchorOffset: new DOMPoint(15, 30),
      };
      var coordinate = new mapkit.Coordinate(latitude, longitude);
      var pinAnnotation = new mapkit.ImageAnnotation(coordinate, pinOptions);
      pinAnnotation.calloutOffset = new DOMPoint(0, 7);
      map.addAnnotation(pinAnnotation);
      setRegion(
        {
          latitude,
          longitude,
          latitudeSpan: DEFAULT_LATITUDE_SPAN,
          longitudeSpan: DEFAULT_LONGITUDE_SPAN,
        },
        true
      );
      return () => {
        map.removeAnnotations(map.annotations);
        map.removeOverlays(map.overlays);
      };
    }
  }, [map]);

  return (
    <div className="d-block map">
      <Map {...mapProps} />
    </div>
  );
};

export default ProjectAppleMap;
